const CustomRequestNewRequestBreadcrumbConstant = [
  {
    title: "User",
    link: "/admin/user_management",
  },
  {
    title: "New User",
    link: "",
    is_active: true,
  },
];

export default CustomRequestNewRequestBreadcrumbConstant;
